import { EntityType } from '@frontend/common';
import { Spinner } from '@frontend/components/common';
import { useModals } from '@frontend/modal';
import { FormattedMessage } from 'react-intl';

import { DefaultContainer } from '../../../modal/detail-modal/default-container/default-container';
import { PlatformObjectBadge } from '../../../modal/platform-object-badge/platform-object-badge.component';
import { useBackupNotificationUserCard } from './backup-notification-user-card.controller';
import { UpdateBackupUserModal } from './update-backup-user-modal/update-backup-user-modal.component';

export interface BackupNotificationUserCardProps {
    entity_id: string;
}

const BACKUP_USER_MODAL_ID = 'backup-user-modal';

/**
 * Will not render if the backup notification address setting (on account) is null
 */
export const BackupNotificationUserCard = (props: BackupNotificationUserCardProps) => {
    const viewProps = useBackupNotificationUserCard(props);
    const { openModal, closeModal } = useModals();

    if (viewProps.backupAddressEnabled === null) {
        return null;
    }

    const renderContent = () => {
        if (viewProps.isLoading) {
            return (
                <div className='flex items-center justify-center py-2'>
                    <Spinner className='text-border-default fill-brand-primary size-4' />
                </div>
            );
        }

        if (!viewProps.backupUserId) {
            return (
                <p className='text-foreground-muted text-sm'>
                    <FormattedMessage
                        id='backup-notification-user-card.no-user'
                        defaultMessage='No backup notification user set'
                    />
                </p>
            );
        }

        return (
            <PlatformObjectBadge
                entityType={EntityType.USER}
                id={viewProps.backupUserId}
                key={viewProps.backupUserId}
            />
        );
    };

    return (
        <DefaultContainer
            title={
                <FormattedMessage
                    id='backup-notification-user-card.title'
                    defaultMessage='Backup Notification User'
                />
            }
            content={renderContent()}
            update={{
                onUpdate: () =>
                    openModal(BACKUP_USER_MODAL_ID, () => (
                        <UpdateBackupUserModal
                            entity_id={props.entity_id}
                            currentBackupUserId={viewProps.backupUserId}
                            onUpdate={async (userId) => {
                                await viewProps.updateBackupUser(userId);
                                closeModal(BACKUP_USER_MODAL_ID);
                            }}
                            isSaving={viewProps.isSaving}
                        />
                    ))
            }}
        />
    );
};
